import { render, staticRenderFns } from "./CategoryCardsSkeleton.vue?vue&type=template&id=5d73f2d5&scoped=true"
import script from "./CategoryCardsSkeleton.vue?vue&type=script&lang=js"
export * from "./CategoryCardsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CategoryCardsSkeleton.vue?vue&type=style&index=0&id=5d73f2d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d73f2d5",
  null
  
)

export default component.exports